<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container">
      <router-link
        :to="brandLink"
        class="navbar-brand me-5"
        @click="hideNavbar"
      >
        <img alt="NOS" class="me-3" src="../../assets/img/nos.png" width="50" />
        <span>Numbers of Success</span>
      </router-link>
      <button
        aria-controls="mainNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
        class="navbar-toggler"
        data-bs-target="#mainNavbar"
        data-bs-toggle="collapse"
        type="button"
        v-if="!buyingProcess"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        id="mainNavbar"
        class="collapse navbar-collapse"
        v-if="!buyingProcess"
      >
        <ul class="navbar-nav me-auto" v-if="emailVerified">
          <li class="nav-item">
            <router-link
              :to="{ name: 'profile' }"
              active-class="active"
              class="nav-link"
              @click="hideNavbar"
            >
              {{ $t("profile") }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'settings' }"
              active-class="active"
              class="nav-link"
              @click="hideNavbar"
            >
              {{ $t("settings") }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'membership' }"
              active-class="active"
              class="nav-link"
              @click="hideNavbar"
            >
              {{ $t("membership") }}
            </router-link>
          </li>
          <li class="nav-item" v-if="isAdmin">
            <router-link
              :to="{ name: 'admin' }"
              active-class="active"
              class="nav-link"
              @click="hideNavbar"
            >
              {{ $t("admin") }}
            </router-link>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item mb-3 mb-lg-0 me-lg-3" v-if="isLoggedIn">
            <button
              class="nav-link btn btn-light text-primary w-100"
              @click.prevent="logout"
              type="button"
            >
              {{ $t("logout") }}
            </button>
          </li>
          <li class="nav-item mb-3 mb-lg-0 me-lg-3" v-if="!isLoggedIn">
            <router-link
              active-class="active"
              class="nav-link btn btn-light text-primary w-100"
              :to="{ name: 'account.login' }"
              @click="hideNavbar"
            >
              {{ $t("login") }}
            </router-link>
          </li>
          <li class="nav-item mb-3 mb-lg-0 me-lg-3" v-if="!isLoggedIn">
            <router-link
              active-class="active"
              class="nav-link btn btn-light text-primary w-100"
              :to="{ name: 'account.register' }"
              @click="hideNavbar"
            >
              {{ $t("register") }}
            </router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              id="navbarDropdown"
              aria-expanded="false"
              class="nav-link btn btn-light text-primary w-100 dropdown-toggle"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
            >
              <span v-for="(long, code, index) in locales" :key="index">
                <span v-if="lang === code">
                  {{ long }}
                </span>
              </span>
            </a>
            <ul aria-labelledby="navbarDropdown" class="dropdown-menu">
              <li v-for="(long, code, index) in locales" :key="index">
                <a
                  :class="lang === code ? 'fw-bold' : ''"
                  class="dropdown-item"
                  href="#"
                  @click.prevent="setLang(code)"
                >
                  {{ long }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from "bootstrap";
import { mapGetters } from "vuex";

export default {
  name: "TheNavbar",
  data() {
    return {
      locales: {
        en: "English",
        de: "Deutsch",
      },
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "user/isLoggedIn",
      emailVerified: "user/isEmailVerified",
      user: "user/getUser",
      isAdmin: "user/isAdmin",
    }),
    brandLink() {
      if (!this.emailVerified) {
        return "#";
      } else if (
        this.$route.name === "membership.extend.30" ||
        this.$route.name === "membership.extend.360"
      ) {
        return { name: "membership.extend" };
      } else {
        return { name: "profile" };
      }
    },
    lang() {
      return this.user.language;
    },
    buyingProcess() {
      if (this.$route.name === "membership.extend.30") return true;
      else if (this.$route.name === "membership.extend.360") return true;
      return false;
    },
  },
  methods: {
    hideNavbar() {
      if (!this.buyingProcess) {
        this.mainNavbar.hide();
      }
    },
    async setLang(locale) {
      await this.$store.dispatch("user/setLanguage", locale);
    },
    async logout() {
      await this.authLogout();
      await this.$router.push({ name: "account.login" });
      await this.hideNavbar();
    },
  },
  mounted() {
    if (!this.buyingProcess) {
      this.mainNavbar = new Collapse(document.getElementById("mainNavbar"), {
        toggle: false,
      });
    }
  },
  updated() {
    if (!this.buyingProcess) {
      this.mainNavbar = new Collapse(document.getElementById("mainNavbar"), {
        toggle: false,
      });
    }
  },
};
</script>

<style scoped></style>
